/* eslint-disable func-names */

const setUserInStorage = function (user) {
    sessionStorage.setItem('current-user', JSON.stringify(user));
};

const getUserFromStorage = function () {
    return JSON.parse(sessionStorage.getItem('current-user')) || null;
};

const getUserRights = function () {
    const user = getUserFromStorage();
    let rights = null;

    if (user) {
        rights = user.user_role;
    }

    return rights;
};

export default { setUserInStorage, getUserFromStorage, getUserRights };



// WEBPACK FOOTER //
// ./src/util/user.js